module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Kandidaten":"The candidate","har skrivit i poolen men det verkar inte som att nån har svarat":"has written in the candidate pool but it does not seem that anyone has answered"},"sv":{"Kandidaten":"Kandidaten","har skrivit i poolen men det verkar inte som att nån har svarat":"har skrivit i er kandidatpool men det verkar inte som att nån har svarat"}}')
  delete Component.options._Ctor
}
